
define('generic/emscripten_fs',["require", "exports", '../core/browserfs', '../core/node_fs', '../core/buffer', '../core/buffer_core_arraybuffer'], function(require, exports, BrowserFS, node_fs, buffer, buffer_core_arraybuffer) {
    var Buffer = buffer.Buffer;
    var BufferCoreArrayBuffer = buffer_core_arraybuffer.BufferCoreArrayBuffer;
    var fs = node_fs.fs;

    var BFSEmscriptenStreamOps = (function () {
        function BFSEmscriptenStreamOps(fs) {
            this.fs = fs;
        }
        BFSEmscriptenStreamOps.prototype.open = function (stream) {
            var path = this.fs.realPath(stream.node);
            try  {
                if (FS.isFile(stream.node.mode)) {
                    stream.nfd = fs.openSync(path, this.fs.flagsToPermissionString(stream.flags));
                }
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenStreamOps.prototype.close = function (stream) {
            try  {
                if (FS.isFile(stream.node.mode) && stream.nfd) {
                    fs.closeSync(stream.nfd);
                }
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenStreamOps.prototype.read = function (stream, buffer, offset, length, position) {
            // Avoid copying overhead by reading directly into buffer.
            var bcore = new BufferCoreArrayBuffer(buffer.buffer);
            var nbuffer = new Buffer(bcore, buffer.byteOffset + offset, buffer.byteOffset + offset + length);
            var res;
            try  {
                res = fs.readSync(stream.nfd, nbuffer, 0, length, position);
            } catch (e) {
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }

            // No copying needed, since we wrote directly into UintArray.
            return res;
        };

        BFSEmscriptenStreamOps.prototype.write = function (stream, buffer, offset, length, position) {
            // Avoid copying overhead; plug the buffer directly into a BufferCore.
            var bcore = new BufferCoreArrayBuffer(buffer.buffer);
            var nbuffer = new Buffer(bcore, buffer.byteOffset + offset, buffer.byteOffset + offset + length);
            var res;
            try  {
                res = fs.writeSync(stream.nfd, nbuffer, 0, length, position);
            } catch (e) {
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
            return res;
        };

        BFSEmscriptenStreamOps.prototype.llseek = function (stream, offset, whence) {
            var position = offset;
            if (whence === 1) {
                position += stream.position;
            } else if (whence === 2) {
                if (FS.isFile(stream.node.mode)) {
                    try  {
                        var stat = fs.fstatSync(stream.nfd);
                        position += stat.size;
                    } catch (e) {
                        throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                    }
                }
            }

            if (position < 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }

            stream.position = position;
            return position;
        };
        return BFSEmscriptenStreamOps;
    })();

    var BFSEmscriptenNodeOps = (function () {
        function BFSEmscriptenNodeOps(fs) {
            this.fs = fs;
        }
        BFSEmscriptenNodeOps.prototype.getattr = function (node) {
            var path = this.fs.realPath(node);
            var stat;
            try  {
                stat = fs.lstatSync(path);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
            return {
                dev: stat.dev,
                ino: stat.ino,
                mode: stat.mode,
                nlink: stat.nlink,
                uid: stat.uid,
                gid: stat.gid,
                rdev: stat.rdev,
                size: stat.size,
                atime: stat.atime,
                mtime: stat.mtime,
                ctime: stat.ctime,
                blksize: stat.blksize,
                blocks: stat.blocks
            };
        };

        BFSEmscriptenNodeOps.prototype.setattr = function (node, attr) {
            var path = this.fs.realPath(node);
            try  {
                if (attr.mode !== undefined) {
                    fs.chmodSync(path, attr.mode);

                    // update the common node structure mode as well
                    node.mode = attr.mode;
                }
                if (attr.timestamp !== undefined) {
                    var date = new Date(attr.timestamp);
                    fs.utimesSync(path, date, date);
                }
                if (attr.size !== undefined) {
                    fs.truncateSync(path, attr.size);
                }
            } catch (e) {
                if (!e.code)
                    throw e;
                if (e.code === "ENOTSUP") {
                    // Ignore not supported errors. Emscripten does utimesSync when it
                    // writes files, but never really requires the value to be set.
                    return;
                }
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenNodeOps.prototype.lookup = function (parent, name) {
            var path = PATH.join2(this.fs.realPath(parent), name);
            var mode = this.fs.getMode(path);
            return this.fs.createNode(parent, name, mode);
        };

        BFSEmscriptenNodeOps.prototype.mknod = function (parent, name, mode, dev) {
            var node = this.fs.createNode(parent, name, mode, dev);

            // create the backing node for this in the fs root as well
            var path = this.fs.realPath(node);
            try  {
                if (FS.isDir(node.mode)) {
                    fs.mkdirSync(path, node.mode);
                } else {
                    fs.writeFileSync(path, '', { mode: node.mode });
                }
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
            return node;
        };

        BFSEmscriptenNodeOps.prototype.rename = function (oldNode, newDir, newName) {
            var oldPath = this.fs.realPath(oldNode);
            var newPath = PATH.join2(this.fs.realPath(newDir), newName);
            try  {
                fs.renameSync(oldPath, newPath);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenNodeOps.prototype.unlink = function (parent, name) {
            var path = PATH.join2(this.fs.realPath(parent), name);
            try  {
                fs.unlinkSync(path);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenNodeOps.prototype.rmdir = function (parent, name) {
            var path = PATH.join2(this.fs.realPath(parent), name);
            try  {
                fs.rmdirSync(path);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenNodeOps.prototype.readdir = function (node) {
            var path = this.fs.realPath(node);
            try  {
                return fs.readdirSync(path);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenNodeOps.prototype.symlink = function (parent, newName, oldPath) {
            var newPath = PATH.join2(this.fs.realPath(parent), newName);
            try  {
                fs.symlinkSync(oldPath, newPath);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };

        BFSEmscriptenNodeOps.prototype.readlink = function (node) {
            var path = this.fs.realPath(node);
            try  {
                return fs.readlinkSync(path);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
        };
        return BFSEmscriptenNodeOps;
    })();

    var BFSEmscriptenFS = (function () {
        function BFSEmscriptenFS() {
            // This maps the integer permission modes from http://linux.die.net/man/3/open
            // to node.js-specific file open permission strings at http://nodejs.org/api/fs.html#fs_fs_open_path_flags_mode_callback
            this.flagsToPermissionStringMap = {
                0: 'r',
                1: 'r+',
                2: 'r+',
                64: 'r',
                65: 'r+',
                66: 'r+',
                129: 'rx+',
                193: 'rx+',
                514: 'w+',
                577: 'w',
                578: 'w+',
                705: 'wx',
                706: 'wx+',
                1024: 'a',
                1025: 'a',
                1026: 'a+',
                1089: 'a',
                1090: 'a+',
                1153: 'ax',
                1154: 'ax+',
                1217: 'ax',
                1218: 'ax+',
                4096: 'rs',
                4098: 'rs+'
            };
            this.node_ops = new BFSEmscriptenNodeOps(this);
            this.stream_ops = new BFSEmscriptenStreamOps(this);
            if (typeof BrowserFS === 'undefined') {
                throw new Error("BrowserFS is not loaded. Please load it before this library.");
            }
        }
        BFSEmscriptenFS.prototype.mount = function (mount) {
            return this.createNode(null, '/', this.getMode(mount.opts.root), 0);
        };

        BFSEmscriptenFS.prototype.createNode = function (parent, name, mode, dev) {
            if (!FS.isDir(mode) && !FS.isFile(mode) && !FS.isLink(mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            var node = FS.createNode(parent, name, mode);
            node.node_ops = this.node_ops;
            node.stream_ops = this.stream_ops;
            return node;
        };

        BFSEmscriptenFS.prototype.getMode = function (path) {
            var stat;
            try  {
                stat = fs.lstatSync(path);
            } catch (e) {
                if (!e.code)
                    throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
            return stat.mode;
        };

        BFSEmscriptenFS.prototype.realPath = function (node) {
            var parts = [];
            while (node.parent !== node) {
                parts.push(node.name);
                node = node.parent;
            }
            parts.push(node.mount.opts.root);
            parts.reverse();
            return PATH.join.apply(null, parts);
        };

        BFSEmscriptenFS.prototype.flagsToPermissionString = function (flags) {
            if (flags in this.flagsToPermissionStringMap) {
                return this.flagsToPermissionStringMap[flags];
            } else {
                return flags;
            }
        };
        return BFSEmscriptenFS;
    })();
    exports.BFSEmscriptenFS = BFSEmscriptenFS;

    // Make it available on the global BrowserFS object.
    BrowserFS['EmscriptenFS'] = BFSEmscriptenFS;
});
//# sourceMappingURL=emscripten_fs.js.map
;